// src/utils/crypto/simple-encrypt-decrypt.ts
var simpleDecrypt = (str) => {
	const expandedStr = str.match(/.{3}/g)?.map(Number);
	return String.fromCharCode(...expandedStr || []);
};
var simpleEncrypt = (str) => str.split("").map((c) => String(c.charCodeAt(0)).padStart(3, "0")).join("");
export { simpleDecrypt, simpleEncrypt };

//# sourceMappingURL=simple-encrypt-decrypt.js.map